import { AccountHttpClient } from 'module/api/account';
import { axiosInstance } from 'api/axios';

export const AccountAPI = new AccountHttpClient(axiosInstance);
